import { createRoot } from 'react-dom/client';

import { ThemeProvider } from '@ssnc/bsds-core';

import { App } from './App';
import { msalInstance } from './features/auth/msalConfig';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element to mount the app into');
}

const root = createRoot(container);

async function main() {
  await msalInstance.initialize();
  // Completes the redirect-based login flow when Entra sends the browser back here.
  await msalInstance.handleRedirectPromise();

  root.render(
    <ThemeProvider>
      <App />
    </ThemeProvider>,
  );
}

main();
